import { motion } from "framer-motion";

const TONES = ["bg-[#E6ECE4]", "bg-[#DCE6DC]", "bg-[#F4F3EC] border border-[#1B3B28]/10"];

const Cards = ({ cards }) => (
  <div className="mt-6 grid gap-4 md:grid-cols-3" data-testid="article-cards">
    {cards.map((c, i) => (
      <motion.div
        key={c.label}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
        className={`rounded-3xl p-6 ${TONES[i % 3]}`}
      >
        <p className="f-mono text-[0.65rem] tracking-[0.24em] uppercase text-[#3E6B48]">{c.label}</p>
        <p className="mt-3 text-sm text-[#1E2922]/85 leading-relaxed">{c.text}</p>
      </motion.div>
    ))}
  </div>
);

const ROWS = { 1: [[57, 8]], 2: [[57, 15], [53.5, 10]], 3: [[58, 15], [54, 15], [50, 13]] };

const Tooth = ({ score }) => {
  const dots = ROWS[score].flatMap(([y, n], row) =>
    Array.from({ length: n }, (_, i) => ({
      x: 26 + (i * 48) / (n - 1) + (((i * 37) % 5) - 2) * 0.5,
      y: y + (((i * 13 + row) % 5) - 2) * 0.5,
      r: 1.2 + ((i + row) % 3) * 0.35,
      hide: score === 1 && i % 3 === 1,
    })),
  ).filter((d) => !d.hide);
  return (
    <svg viewBox="0 4 100 80" className="w-28 h-24 mx-auto" aria-hidden="true">
      <path d="M50 10c-9 0-13 4-21 4S16 11 16 25c0 11 4 17 6 30 2 11 4 26 10 26 6 0 5-18 9-23 2-2 5-3 9-3s7 1 9 3c4 5 3 23 9 23 6 0 8-15 10-26 2-13 6-19 6-30 0-14-5-11-13-11s-12-4-21-4z" fill="#FCFBF7" stroke="#1B3B28" strokeWidth="1.4" />
      <path d="M4 66 Q27 57 50 63 Q73 57 96 66 L96 90 L4 90 Z" fill="#C9D6C6" />
      {dots.map((d, i) => <circle key={i} cx={d.x} cy={d.y} r={d.r} fill="#1E2922" opacity="0.85" />)}
    </svg>
  );
};

const Scores = ({ scores }) => (
  <div className="mt-6 grid gap-4 sm:grid-cols-3" data-testid="article-scores">
    {scores.map((t, i) => (
      <div key={t} className={`rounded-3xl p-6 text-center ${TONES[i]}`} data-testid={`article-score-${i + 1}`}>
        <Tooth score={i + 1} />
        <p className="f-mono text-[0.65rem] tracking-[0.24em] uppercase text-[#3E6B48] mt-3">Score {i + 1}</p>
        <p className="mt-2 text-sm text-[#1E2922]/85 leading-relaxed">{t}</p>
      </div>
    ))}
  </div>
);

export const ArticleBlocks = ({ s }) => (
  <>
    {s.cards && <Cards cards={s.cards} />}
    {s.scores && <Scores scores={s.scores} />}
    {s.note && (
      <p className="mt-6 rounded-2xl bg-[#1B3B28] text-[#FCFBF7] px-6 py-5 text-sm leading-relaxed" data-testid="article-note">
        {s.note}
      </p>
    )}
  </>
);
